// extracted by mini-css-extract-plugin
export default {"search-sort":"DisplayedByName_search-sort__x9XkT"};